package com.rainbowclubs.rainbow.presentation.splash

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.rainbowclubs.rainbow.domain.use_cases.club.GetSelectedClubIdUseCase
import com.rainbowclubs.rainbow.domain.use_cases.login.IsUserLoggedInUseCase
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.launch

class SplashViewModel(
    private val isUserLoggedInUseCase: IsUserLoggedInUseCase,
    private val getSelectedClubIdUseCase: GetSelectedClubIdUseCase,
) : ViewModel() {
    private val navigationIntentChannel = Channel<SplashNavigationEvent>(Channel.BUFFERED)
    val navigationIntent: Flow<SplashNavigationEvent> = navigationIntentChannel.receiveAsFlow()
    fun navigate() {
        viewModelScope.launch {
            val isUserLoggedIn = isUserLoggedInUseCase.run().getOrElse { false }
            val cachedClubId = getSelectedClubIdUseCase()

            val destination = when {
                !isUserLoggedIn -> SplashNavigationEvent.Landing
                cachedClubId.isNullOrBlank() -> SplashNavigationEvent.SelectClub
                else -> SplashNavigationEvent.Home(cachedClubId)
            }

            navigationIntentChannel.send(destination)
        }
    }
}

sealed class SplashNavigationEvent {
    object Landing : SplashNavigationEvent()
    data class Home(val clubId: String) : SplashNavigationEvent()
    object SelectClub : SplashNavigationEvent()
}
